export const ticketTypes = {
    GET_ALL_TICKETS_START: 'GET_ALL_TICKETS_START',
    GET_ALL_TICKETS_SUCCESS: 'GET_ALL_TICKETS_SUCCESS',
    GET_ALL_TICKETS_FAILED: 'GET_ALL_TICKETS_FAILED',
    GET_ALL_TICKETS_END: 'GET_ALL_TICKETS_END',

    CREATE_A_TICKET_START: 'CREATE_A_TICKET_START',
    CREATE_A_TICKET_SUCCESS: 'CREATE_A_TICKET_SUCCESS',
    CREATE_A_TICKET_FAILED: 'CREATE_A_TICKET_FAILED',
    CREATE_A_TICKET_END: 'CREATE_A_TICKET_END',

    ADD_MESSAGE_TO_TICKET_START: 'ADD_MESSAGE_TO_TICKET_START',
    ADD_MESSAGE_TO_TICKET_SUCCESS: 'ADD_MESSAGE_TO_TICKET_SUCCESS',
    ADD_MESSAGE_TO_TICKET_FAILED: 'ADD_MESSAGE_TO_TICKET_FAILED',
    ADD_MESSAGE_TO_TICKET_END: 'ADD_MESSAGE_TO_TICKET_END',

    UPDATE_TICKET_START: 'UPDATE_TICKET_START',
    UPDATE_TICKET_SUCCESS: 'UPDATE_TICKET_SUCCESS',
    UPDATE_TICKET_FAILED: 'UPDATE_TICKET_FAILED',
    UPDATE_TICKET_END: 'UPDATE_TICKET_END',
}
